import React, { useCallback, useEffect, useState, useMemo } from 'react';
import { Trash2, CheckCircle, MapPin, Plus, Eye, X, Clock, User, Phone, Mail, Hash } from 'lucide-react';
import toast from 'react-hot-toast';
import axios from 'axios';
import { cn } from '../utils/cn.js';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  TouchSensor,
  PointerSensor,
  useSensor,
  useSensors
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy
} from '@dnd-kit/sortable';
import { SortableItem } from './SortableItems';
import GoogleInput from './GoogleInput';
import APIENDPOINT from './config.js';
export const BookingForm = () => {
  const [formData, setFormData] = useState({
    name: '', phone_number: '', whatsapp_number: '', email: '',
    journey_date: '', journey_time: '', save_new_pickaddress: '',
    pickup_type: '', pickup_address_name: '', pickup_address: '', pickup_lat: '', pickup_lng: '', pickup_address_notes: '', new_pickup_address_name: '', save_new_dropaddress: '',
    drop_type: '', drop_address_name: '', drop_address: '', drop_lat: '', drop_lng: '', drop_address_notes: '', new_drop_address_name: '',
    price: '', distance: 0, notes: '', people: '1', luggage: 'No luggage', is_return: 0, airport_trip: 0, assigned_id: 0
  });
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [points, setPoints] = useState([]);
  const [loading, setLoading] = useState(false);
  const [priceList, setPriceList] = useState([]);
  const [pricingRules, setPricingRules] = useState(null);
  const [bookingHistory, setBookingHistory] = useState([]);
  const [save_new_dropaddress, setSave_new_dropaddress] = useState(false)
  const [save_new_pickaddress, setSave_new_pickaddress] = useState(false)
  const [masterLocations, setMasterLocations] = useState([]);
  const [driverList, setDriverList] = useState([]);
  const railwayList = [
    { id: 1, name: "Ebbsfleet International", lat: 51.4432, lng: 0.3215 },
    { id: 2, name: "Ashford International", lat: 51.1432, lng: 0.8754 },
    { id: 3, name: "St Pancras International", lat: 51.5319, lng: -0.1263 }
  ];
  const [driver, setDriver] = useState([
    { id: 1, name: "Pandi" }, { id: 2, name: "Driver1" },
  ])

  const airportList = [
    { id: 1, name: "Heathrow T1", lat: 51.4700, lng: -0.4543 },
    { id: 2, name: "Heathrow T2", lat: 51.4706, lng: -0.4594 },
    { id: 3, name: "Heathrow T3", lat: 51.4719, lng: -0.4563 },
    { id: 4, name: "Heathrow T4", lat: 51.4590, lng: -0.4450 },
    { id: 5, name: "Heathrow T5", lat: 51.4700, lng: -0.4900 },
    { id: 6, name: "Gatwick South", lat: 51.1560, lng: -0.1610 },
    { id: 7, name: "Gatwick North", lat: 51.1605, lng: -0.1821 },
    { id: 8, name: "London Stansted", lat: 51.8850, lng: 0.2350 },
    { id: 9, name: "London Luton", lat: 51.8747, lng: -0.3683 },
    { id: 10, name: "London City Airport", lat: 51.5053, lng: 0.0553 },
    { id: 11, name: "London Biggin Hill Airport", lat: 51.3308, lng: 0.0325 },
    { id: 12, name: "Southend Airport", lat: 51.5714, lng: 0.6956 }
  ];
  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const res = await axios.get(`${APIENDPOINT}master.php?action=list`);
        setMasterLocations(res.data);
      } catch (err) { console.error("Error fetching master locations", err); }
    };
    fetchLocations();
  }, []);
  useEffect(() => {
    const fetchDrivers = async () => {
      try {
        const res = await axios.get(`${APIENDPOINT}booking.php?action=getDrivers`);

        setDriverList(res.data);
      } catch (err) {
        console.error("Error fetching drivers", err);
      }
    };
    fetchDrivers();
  }, []);
  const dynamicCategories = useMemo(() => {
    const categories = masterLocations.map(loc => loc.primary_name);
    return [...new Set(categories)]; // Returns unique list: ['Airport', 'Railway Station', 'Hospital', ...]
  }, [masterLocations]);

  const handleSpecificLocationSelect = (locationName, type) => {
    const loc = masterLocations.find(l => l.location_name === locationName);
    const isPickup = type === 'pickup';

    if (loc) {
      setFormData(prev => ({
        ...prev,
        [isPickup ? 'pickup_address_name' : 'drop_address_name']: loc.location_name,
        [isPickup ? 'pickup_address' : 'drop_address']: loc.address || loc.location_name,
        [isPickup ? 'pickup_lat' : 'drop_lat']: loc.latitude,
        [isPickup ? 'pickup_lng' : 'drop_lng']: loc.longitude
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [isPickup ? 'pickup_address' : 'drop_address']: '',
        [isPickup ? 'pickup_lat' : 'drop_lat']: '',
        [isPickup ? 'pickup_lng' : 'drop_lng']: ''
      }));
    }
  };

  const [savedAddresses, setSavedAddresses] = useState([]);
  const handleViewDetails = async (booking) => {
    setDetailLoading(true);
    try {
      const res = await fetch(`${APIENDPOINT}booking.php?action=getDetail&id=${booking.id}`);
      const data = await res.json();

      setSelectedBooking(data);
      setIsModalOpen(true);
    } catch (error) {
      toast.error("Failed to fetch stop details");
    } finally {
      setDetailLoading(false);
    }
  };
  const handlePhoneSearch = async (phone) => {
    if (phone.length >= 10) {
      try {
        const res = await fetch(`${APIENDPOINT}booking.php?action=fetchByPhone&phone=${encodeURIComponent(phone)}`);
        const result = await res.json();

        if (result.found) {
          const u = result.user; // User data from user_data table

          setFormData(prev => ({
            ...prev,
            // Populate User Profile
            name: u.name || '',
            email: u.email || '',
            whatsapp_number: u.whatsapp_number || '',

            // RESET Journey Details for NEW booking
            journey_date: '',
            journey_time: '',
            pickup_type: '',
            pickup_address_name: '',
            pickup_address: '',
            pickup_lat: '',
            pickup_lng: '',
            pickup_address_notes: '',
            new_pickup_address_name: '',
            assigned_id: 0,
            drop_type: '',
            drop_address_name: '',
            drop_address: '',
            drop_lat: '',
            drop_lng: '',
            drop_address_notes: '',
            new_drop_address_name: '',
            airport_trip: 0,
            notes: '',
            price: '',
            distance: 0,
            is_return: 0,
            people: '1',
            luggage: 'No luggage'
          }));


          setPoints([]);

          // Populate Saved Addresses dropdown
          setSavedAddresses(result.saved_addresses || []);
          const historyRes = await fetch(`${APIENDPOINT}booking.php?action=getbookingHistory&phone=${encodeURIComponent(phone)}`);
          const historyData = await historyRes.json();
          setBookingHistory(historyData);

          setSave_new_pickaddress(false);
          setSave_new_dropaddress(false);
        } else {
          setBookingHistory([]);
        }
      } catch (error) {
        console.error('Error searching phone:', error);
      }
    } else {
      setBookingHistory([]);
    }
  };



  const handleSubmit = async (e) => {
    // console.log(formData, "-=========formdata=========-")
    // console.log(points, "-=========formdata=========-")
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        formData,
        points
      };
      const response = await fetch(`${APIENDPOINT}booking.php?action=create`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      if (response.ok) {
        toast.success("Booking submitted successfully!");
        setFormData({
          name: '', phone_number: '', whatsapp_number: '', email: '',
          journey_date: '', journey_time: '', save_new_pickaddress: '',
          pickup_type: '', pickup_address_name: '', pickup_address: '', pickup_lat: '', pickup_lng: '', pickup_address_notes: '', new_pickup_address_name: '', save_new_dropaddress: '',
          drop_type: '', drop_address_name: '', drop_address: '', drop_lat: '', drop_lng: '', drop_address_notes: '', new_drop_address_name: '',
          price: '', distance: 0, notes: '', people: '1', luggage: 'No luggage', is_return: 0, airport_trip: 0, assigned_id: 0
        });
        setPoints([]);
      }
    } catch (err) {
      console.error(err);
      toast.error("Error submitting booking");
    } finally {
      setLoading(false);
    }
  };

  const addPoint = () => {
    if (points.length < 10) {
      setPoints([...points, { id: Math.random().toString(36).substr(2, 9), address: '', lat: 0, lng: 0 }]);
    }
  };

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
    useSensor(TouchSensor, {

      activationConstraint: {
        delay: 250,
        tolerance: 5,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over?.id) {
      setPoints((items) => {
        const oldIndex = items.findIndex((i) => i.id === active.id);
        const newIndex = items.findIndex((i) => i.id === over?.id);
        return arrayMove(items, oldIndex, newIndex);
      });
    }
  };

  const updatePoint = useCallback((index, address, lat, lng) => {
    setPoints(prevPoints => {
      const newPoints = [...prevPoints];
      newPoints[index] = { ...newPoints[index], address, lat, lng };
      return newPoints;
    });
  }, []);



  const calculateTieredFare = useCallback((miles) => {
    if (!pricingRules) return 0;

    const m = parseFloat(miles) || 0;
    const baseDist = parseFloat(pricingRules.base_distance || 2.0);
    const basePrice = parseFloat(pricingRules.base_price || 6.0);
    const ratePerMile = parseFloat(pricingRules.price_per_mile || 2.60);
    const step = parseFloat(pricingRules.step_distance || 0.5);

    const roundedMiles = Math.ceil(m / step) * step;

    if (roundedMiles <= baseDist) return basePrice;

    const extraMiles = roundedMiles - baseDist;
    const totalFare = basePrice + (extraMiles * ratePerMile);

    return totalFare;
  }, [pricingRules]);
  const calculateDistanceAndPrice = useCallback(() => {
    if (!window.google || !formData.pickup_lat || !formData.drop_lat) return;

    const ds = new window.google.maps.DirectionsService();
    const wp = points
      .filter(p => p.lat && p.lng)
      .map(p => ({
        location: { lat: Number(p.lat), lng: Number(p.lng) },
        stopover: true
      }));

    ds.route({
      origin: { lat: Number(formData.pickup_lat), lng: Number(formData.pickup_lng) },
      destination: { lat: Number(formData.drop_lat), lng: Number(formData.drop_lng) },
      waypoints: wp,
      travelMode: window.google.maps.TravelMode.DRIVING,
    }, (result, status) => {
      if (status === "OK") {
        let totalMeters = 0;
        result.routes[0].legs.forEach(leg => { totalMeters += leg.distance.value; });

        const miles = totalMeters / 1609.34;
        const finalPrice = calculateTieredFare(miles);

        setFormData(prev => ({
          ...prev,
          distance: miles.toFixed(2),
          price: finalPrice.toFixed(2)
        }));
      }
    });
  }, [formData.pickup_lat, formData.pickup_lng, formData.drop_lat, formData.drop_lng, points, calculateTieredFare]);

  useEffect(() => {
    const fetchPricing = async () => {
      try {
        const response = await fetch(`${APIENDPOINT}booking.php?action=getPricing`);
        const data = await response.json();
        setPricingRules(data);
      } catch (error) {
        console.error("Failed to fetch pricing:", error);
      }
    };
    fetchPricing();
  }, []);

  useEffect(() => {
    calculateDistanceAndPrice();
  }, [calculateDistanceAndPrice]);

  const handleAddressDropdownChange = (e, type) => {
    const val = e.target.value;
    const isPickup = type === 'pickup';
    const saved = savedAddresses.find(a => a.address_name === val && a.address_type === type);

    if (saved) {
      setFormData(prev => ({
        ...prev,
        [isPickup ? 'pickup_type' : 'drop_type']: 'Saved Address',
        [isPickup ? 'pickup_address_name' : 'drop_address_name']: saved.address_name,
        // PRE-FILL THE EDITABLE NAME FIELD
        [isPickup ? 'new_pickup_address_name' : 'new_drop_address_name']: saved.address_name,
        [isPickup ? 'pickup_address' : 'drop_address']: saved.address,
        [isPickup ? 'pickup_lat' : 'drop_lat']: saved.latitude,
        [isPickup ? 'pickup_lng' : 'drop_lng']: saved.longitude,
        [isPickup ? 'pickup_address_notes' : 'drop_address_notes']: saved.address_notes || '',
      }));
      isPickup ? setActivePickupId(saved.id) : setActiveDropId(saved.id);
    } else {
      setFormData(prev => ({
        ...prev,
        [isPickup ? 'pickup_type' : 'drop_type']: val,
        [isPickup ? 'pickup_address_name' : 'drop_address_name']: val,
        // CLEAR THE NAME FIELD IF CLICKED "ADD NEW ADDRESS"
        [isPickup ? 'new_pickup_address_name' : 'new_drop_address_name']: '',
        [isPickup ? 'pickup_address' : 'drop_address']: '',
      }));
      isPickup ? setActivePickupId(null) : setActiveDropId(null);
    }
  };
  const handleSaveAddressClick = (type) => {
    const currentCount = savedAddresses.filter(a => a.address_type === type).length;
    if (currentCount >= 2) {
      toast.error(`Maximum of 2 saved addresses allowed for ${type}.`);
      return;
    }
    if (type === 'pickup') {
      const newState = !save_new_pickaddress;
      setSave_new_pickaddress(newState);
      setFormData(f => ({ ...f, save_new_pickaddress: newState ? "true" : "false" }));
    } else {
      const newState = !save_new_dropaddress;
      setSave_new_dropaddress(newState);
      setFormData(f => ({ ...f, save_new_dropaddress: newState ? "true" : "false" }));
    }
  };
  const [activePickupId, setActivePickupId] = useState(null);
  const [activeDropId, setActiveDropId] = useState(null);
  const AddressActions = ({ type, isSaved, onSave, activeId, count }) => (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={onSave}
        className={cn(
          "flex items-center justify-center gap-2 h-11 px-6 rounded-xl border font-bold text-xs transition-all",
          isSaved ? "bg-emerald-600 border-emerald-600 text-white" : "bg-white border-gray-200 text-gray-600 hover:bg-gray-50"
        )}
      >
        {isSaved ? <CheckCircle size={16} /> : null}
        {isSaved ? 'Saved' : 'Save'}
      </button>

      {activeId && (
        <button
          type="button"
          onClick={() => deleteSavedAddress(activeId, type)}
          className="p-3 text-rose-500 bg-rose-50 rounded-xl hover:bg-rose-100 transition-colors"
          title="Delete Saved Address"
        >
          <Trash2 size={18} />
        </button>
      )}

      {count >= 2 && !isSaved && !activeId && (
        <span className="text-[10px] text-rose-500 font-bold uppercase">Limit (2/2)</span>
      )}
    </div>
  );
  const deleteSavedAddress = async (id, type) => {
    if (!window.confirm("Are you sure you want to delete this saved address?")) return;
    try {
      const res = await fetch(`${APIENDPOINT}booking.php?action=deleteAddress`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id })
      });
      if (res.ok) {
        handlePhoneSearch(formData.phone_number);
        if (type === 'pickup') {
          setFormData(f => ({ ...f, pickup_type: 'Add New Address', pickup_address_name: '', pickup_address: '' }));
          setActivePickupId(null);
        } else {
          setFormData(f => ({ ...f, drop_type: 'Add New Address', drop_address_name: '', drop_address: '' }));
          setActiveDropId(null);
        }
      }
    } catch (err) { console.error(err); }
  };
  const today = new Date().toISOString().split('T')[0];
  const currentTime = new Date().toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit'
  });

  const [countryCode, setCountryCode] = useState('+44');
  const [localNumber, setLocalNumber] = useState('');

  // Helper to update the actual formData
  const updateFullPhone = (code, number) => {
    const fullNumber = `${code}${number}`;
    setFormData(prev => ({ ...prev, phone_number: fullNumber }));
    handlePhoneSearch(fullNumber);
  };
  return (
    <div className='row' style={{ rowGap: "20px" }}>


      <div className='col-12 col-md-8 col-sm-12 col-lg-8 col-xl-8 col-xm-12'>
        <form onSubmit={handleSubmit} className="max-w-4xl mx-auto bg-white p-4 sm:p-8 rounded-2xl border border-gray-100 shadow-sm space-y-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700">Phone Number</label>
              <div className="flex gap-2">
                <select
                  className="w-28 px-3 py-2 rounded-xl border border-gray-200 focus:ring-2 focus:ring-emerald-500 outline-none bg-white text-sm"
                  value={countryCode}
                  onChange={(e) => {
                    const newCode = e.target.value;
                    setCountryCode(newCode);
                    updateFullPhone(newCode, localNumber);
                  }}
                >
                  <option value="+44">+44 (UK)</option>
                  <option value="+1">+1 (USA)</option>
                  <option value="+33">+33 (FR)</option>
                  <option value="+49">+49 (DE)</option>
                  <option value="+91">+91 (IN)</option>
                  <option value="+971">+971 (UAE)</option>
                </select>

                <input
                  type="tel"
                  placeholder="7123456789"
                  required
                  className="flex-1 px-4 py-2 rounded-xl border border-gray-200 focus:ring-2 focus:ring-emerald-500 outline-none"
                  value={localNumber}
                  onChange={(e) => {
                    const val = e.target.value.replace(/^0+/, '');
                    setLocalNumber(val);
                    updateFullPhone(countryCode, val);
                  }}
                />
              </div>
              {/* <p className="text-[10px] text-gray-400 ml-1">
                Value saved: <span className="font-mono font-bold text-emerald-600">{formData.phone_number}</span>
              </p> */}
            </div>
            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700">Whatsapp Number</label>
              <input
                type="text"
                className="w-full px-4 py-2 rounded-xl border border-gray-200 focus:ring-2 focus:ring-emerald-500 outline-none"
                value={formData.whatsapp_number}
                onChange={(e) => setFormData({ ...formData, whatsapp_number: e.target.value })}
              />
            </div>
            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700">Name</label>
              <input
                type="text"
                required
                className="w-full px-4 py-2 rounded-xl border border-gray-200 focus:ring-2 focus:ring-emerald-500 outline-none"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              />
            </div>
            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700">Email</label>
              <input
                type="email"
                className="w-full px-4 py-2 rounded-xl border border-gray-200 focus:ring-2 focus:ring-emerald-500 outline-none"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              />
            </div>
            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700">Journey Date</label>
              <input
                type="date"
                required
                min={today} // Prevents past dates
                className="w-full px-4 py-2 rounded-xl border border-gray-200 focus:ring-2 focus:ring-emerald-500 outline-none"
                value={formData.journey_date}
                onChange={(e) => {
                  const selectedDate = e.target.value;
                  // If user switches back to today and the previously selected time is now in the past, clear time
                  let updateTime = formData.journey_time;
                  if (selectedDate === today && formData.journey_time < currentTime) {
                    updateTime = '';
                  }
                  setFormData({ ...formData, journey_date: selectedDate, journey_time: updateTime });
                }}
              />
            </div>

            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700">Journey Time</label>
              <input
                type="time"
                required
                // Restrict time ONLY if the selected date is today
                min={formData.journey_date === today ? currentTime : ""}
                className="w-full px-4 py-2 rounded-xl border border-gray-200 focus:ring-2 focus:ring-emerald-500 outline-none"
                value={formData.journey_time}
                onChange={(e) => {
                  const selectedTime = e.target.value;
                  if (formData.journey_date === today && selectedTime < currentTime) {
                    toast.error("Please select a future time");
                    return;
                  }
                  setFormData({ ...formData, journey_time: selectedTime });
                }}
              />
            </div>

          </div>

          <div className="space-y-6">
            <div className="p-6 bg-gray-50 rounded-2xl space-y-4 border border-gray-100">
              <h3 className="font-bold text-gray-900 flex items-center gap-2"><MapPin className="w-5 h-5 text-emerald-600" /> Pickup</h3>

              <select
                className="w-full px-4 py-2 rounded-xl border border-gray-200 bg-white font-medium"
                value={formData.pickup_type}
                onChange={(e) => handleAddressDropdownChange(e, 'pickup')}
              >
                <option value="">Select Pickup Type</option>

                {dynamicCategories.map(cat => (
                  <option key={cat} value={cat}>{cat}</option>
                ))}

                <option value="Add New Address">Add New Custom Address</option>

                {savedAddresses.filter(a => a.address_type === 'pickup').map(addr => (
                  <option key={addr.id} value={addr.address_name}>{addr.address_name} (Saved)</option>
                ))}
              </select>

              {dynamicCategories.includes(formData.pickup_type) && (
                <select
                  className="w-full px-4 py-2 rounded-xl border border-emerald-500 bg-white font-bold shadow-sm animate-in fade-in zoom-in duration-150"
                  value={formData.pickup_address_name}
                  onChange={(e) => handleSpecificLocationSelect(e.target.value, 'pickup')}
                >
                  <option value="">Select {formData.pickup_type}</option>

                  {masterLocations
                    .filter(loc => loc.primary_name === formData.pickup_type)
                    .map(loc => (
                      <option key={loc.id} value={loc.location_name}>
                        {loc.location_name} {loc.address ? `(${loc.address.substring(0, 25)}...)` : ''}
                      </option>
                    ))}
                </select>
              )}

              {(formData.pickup_type === 'Add New Address' || formData.pickup_type === 'Saved Address') && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2 animate-in fade-in duration-150">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2">
                    <input
                      placeholder="Address Name"
                      value={formData.new_pickup_address_name}
                      className="px-4 py-2 rounded-xl border border-gray-200"
                      onChange={e => setFormData({ ...formData, new_pickup_address_name: e.target.value })}
                    />
                    <input
                      placeholder="House No / Notes"
                      value={formData.pickup_address_notes}
                      className="px-4 py-2 rounded-xl border border-gray-200"
                      onChange={e => setFormData({ ...formData, pickup_address_notes: e.target.value })}
                    />
                    <GoogleInput
                      value={formData.pickup_address}
                      className={"px-4 py-2 rounded-xl border border-gray-200 w-full"}
                      onSelect={(p) => setFormData({ ...formData, pickup_address: p.address, pickup_lat: p.lat, pickup_lng: p.lng })}
                    />
                    <AddressActions
                      type="pickup"
                      isSaved={save_new_pickaddress}
                      onSave={() => handleSaveAddressClick('pickup')}
                      activeId={activePickupId}
                      count={savedAddresses.filter(a => a.address_type === 'pickup').length}
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="p-6 bg-gray-50 rounded-2xl space-y-4 border border-gray-100">
              <h3 className="font-bold text-gray-900 flex items-center gap-2"><MapPin className="w-5 h-5 text-rose-600" /> Drop</h3>

              <select
                className="w-full px-4 py-2 rounded-xl border border-gray-200 bg-white font-medium"
                value={formData.drop_type}
                onChange={(e) => handleAddressDropdownChange(e, 'drop')}
              >
                <option value="">Select Drop Type</option>
                {dynamicCategories.map(cat => (
                  <option key={cat} value={cat}>{cat}</option>
                ))}
                <option value="Add New Address">Add New Custom Address</option>
                {savedAddresses.filter(a => a.address_type === 'drop').map(addr => (
                  <option key={addr.id} value={addr.address_name}>{addr.address_name} (Saved)</option>
                ))}
              </select>

              {/* Dropdown 2: Shows specific locations ONLY IF a DB category is selected */}
              {dynamicCategories.includes(formData.drop_type) && (
                <select
                  className="w-full px-4 py-2 rounded-xl border border-rose-500 bg-white font-bold  shadow-sm animate-in fade-in zoom-in duration-150"
                  value={formData.drop_address_name}
                  onChange={(e) => handleSpecificLocationSelect(e.target.value, 'drop')}
                >
                  <option value="">Select specific {formData.drop_type}</option>
                  {masterLocations
                    .filter(loc => loc.primary_name === formData.drop_type)
                    .map(loc => (
                      <option key={loc.id} value={loc.location_name}>
                        {loc.location_name} {loc.address ? `(${loc.address.substring(0, 25)}...)` : ''}
                      </option>
                    ))}
                </select>
              )}

              {(formData.drop_type === 'Add New Address' || formData.drop_type === 'Saved Address') && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2">
                  <input
                    placeholder="Address Name"
                    value={formData.new_drop_address_name}
                    className="px-4 py-2 rounded-xl border border-gray-200"
                    onChange={e => setFormData({ ...formData, new_drop_address_name: e.target.value })}
                  />
                  <input placeholder="House No / Notes" value={formData.drop_address_notes} className="px-4 py-2 rounded-xl border border-gray-200" onChange={e => setFormData({ ...formData, drop_address_notes: e.target.value })} />
                  <GoogleInput value={formData.drop_address} className={"px-4 py-2 rounded-xl border border-gray-200 w-full"} onSelect={(p) => setFormData({ ...formData, drop_address: p.address, drop_lat: p.lat, drop_lng: p.lng })} />

                  <AddressActions
                    type="drop"
                    isSaved={save_new_dropaddress}
                    onSave={() => handleSaveAddressClick('drop')}
                    activeId={activeDropId}
                    count={savedAddresses.filter(a => a.address_type === 'drop').length}
                  />
                </div>
              )}

            </div>
          </div>

          <div className="space-y-4">
            <div className="flex justify-between items-center">
              <h3 className="font-bold text-gray-900">Drop / Pickup Points</h3>
              <button type="button" onClick={addPoint} className="text-emerald-600 flex items-center gap-1 text-sm font-semibold hover:underline">
                <Plus className="w-4 h-4" /> Add Point
              </button>
            </div>
            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragEnd={handleDragEnd}
            >
              <SortableContext
                items={points.map(p => p.id)}
                strategy={verticalListSortingStrategy}
              >
                <div className="space-y-3">
                  {points.map((point, index) => (
                    <SortableItem
                      key={point.id}
                      id={point.id}
                      point={point}
                      index={index}
                      onChange={updatePoint}
                      onRemove={(id) => setPoints(points.filter(p => p.id !== id))}
                    />
                  ))}
                </div>
              </SortableContext>
            </DndContext>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700">Distance (Miles)</label>
              <div className="flex gap-2">
                <input
                  readOnly
                  className="flex-1 px-4 py-2 rounded-xl border border-gray-200 bg-gray-50"
                  value={formData.distance}
                />
                {/* <button type="button" onClick={calculateDistance} className="px-4 py-2 bg-gray-900 text-white rounded-xl text-sm font-bold">Calculate</button> */}
              </div>
            </div>
            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700">Price (£)</label>
              <input
                type="number"
                step="0.01"
                className="w-full px-4 py-2 rounded-xl border border-gray-200 focus:ring-2 focus:ring-emerald-500 outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                value={formData.price}
                onChange={(e) => setFormData({ ...formData, price: e.target.value })}
                onBlur={(e) => {
                  const val = parseFloat(e.target.value);
                  if (!isNaN(val)) {
                    setFormData({ ...formData, price: val.toFixed(2) });
                  }
                }}
              />

            </div>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-semibold text-gray-700">Notes</label>
            <textarea
              rows={5}
              className="w-full px-4 py-2 rounded-xl border border-gray-200 focus:ring-2 focus:ring-emerald-500 outline-none resize-none"
              value={formData.notes}
              onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
            />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700">How many people</label>
              <select
                className="w-full px-4 py-2 rounded-xl border border-gray-200 bg-white"
                value={formData.people}
                onChange={(e) => setFormData({ ...formData, people: e.target.value })}
              >
                {[1, 2, 3, 4, 5, 6, 7, 8].map(n => <option key={n} value={n}>{n}</option>)}
              </select>
            </div>
            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700">How many luggage</label>
              <select
                className="w-full px-4 py-2 rounded-xl border border-gray-200 bg-white"
                value={formData.luggage}
                onChange={(e) => setFormData({ ...formData, luggage: e.target.value })}
              >
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(n => <option key={n} value={n}>{n}</option>)}
                <option value="No luggage">No luggage</option>
                <option value="Hand luggage only">Hand luggage only</option>
              </select>
            </div>
          </div>
          <div className="flex flex-col md:flex-row md:items-center gap-6 p-4 bg-gray-50 rounded-2xl border border-gray-100">
            <div className="flex items-center gap-3 group cursor-pointer" onClick={() => setFormData({ ...formData, is_return: formData.is_return === 1 ? 0 : 1 })}>
              <div className={cn(
                "w-6 h-6 rounded-lg border-2 flex items-center justify-center transition-all",
                formData.is_return === 1 ? "bg-emerald-600 border-emerald-600" : "bg-white border-gray-300"
              )}>
                {formData.is_return === 1 && <CheckCircle className="w-4 h-4 text-white" />}
              </div>
              <label className="text-sm font-bold text-gray-700 cursor-pointer select-none">
                Do you want to book a return journey?
              </label>
            </div>


          </div>
          <div className="flex items-center gap-2 bg-white p-1 rounded-xl border border-gray-200 w-fit">
            <button
              type="button"
              onClick={() => setFormData({ ...formData, airport_trip: 0 })}
              className={cn(
                "px-4 py-2 rounded-lg text-xs font-bold transition-all",
                formData.airport_trip === 0
                  ? "bg-emerald-600 text-white shadow-md"
                  : "text-gray-500 hover:bg-gray-50"
              )}
            >
              Local Job
            </button>
            <button
              type="button"
              onClick={() => setFormData({ ...formData, airport_trip: 1 })}
              className={cn(
                "px-4 py-2 rounded-lg text-xs font-bold transition-all",
                formData.airport_trip === 1
                  ? "bg-emerald-600 text-white shadow-md"
                  : "text-gray-500 hover:bg-gray-50"
              )}
            >
              Airport Trip
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700">Assign Driver</label>
              <select
                className="w-full px-4 py-2 rounded-xl border border-gray-200 bg-white capitalize"
                value={formData.assigned_id}
                onChange={(e) => setFormData({ ...formData, assigned_id: e.target.value })}
              >
                <option value="0">- Select User -</option>
                {driverList.map((d) => (
                  <option key={d.id} value={d.id}>
                    {d.name} ({d.user_type === 1 ? 'Admin' : 'Driver'})
                  </option>
                ))}
              </select>
            </div>
          </div>

          <button
            disabled={loading}
            className="w-full py-4 bg-emerald-600 hover:bg-emerald-700 text-white rounded-2xl font-bold text-lg transition-all disabled:opacity-50"
          >
            {loading ? 'Submitting...' : 'Submit Booking'}
          </button>
        </form >
      </div>
      <div className='col-12 col-md-4 col-sm-12 col-lg-4 col-xl-4 col-xm-12'>
        <div className="bg-white p-4 rounded-2xl border border-gray-100 shadow-sm sticky top-4">
          <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
            <CheckCircle className="text-emerald-600" size={20} />
            Recent Bookings
          </h3>

          {bookingHistory.length === 0 ? (
            <div className="text-center py-8 text-gray-400">
              <p className="text-sm">No booking history found for this number.</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-left text-sm">
                <thead>
                  <tr className="border-b border-gray-100">
                    <th className="pb-2 font-semibold text-gray-600">Date/Time</th>
                    <th className="pb-2 font-semibold text-gray-600">Route</th>
                    <th className="pb-2 font-semibold text-gray-600 text-right">Price</th>
                    <th className="pb-2 font-semibold text-gray-600 text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {bookingHistory.map((booking) => (
                    <tr key={booking.id} className="...">
                      <td className="py-3">
                        <div className="font-bold text-gray-900">{booking.journey_date}</div>
                        <div className="text-xs text-gray-500">{booking.journey_time}</div>
                      </td>
                      <td className="py-3 px-2">
                        <div className="line-clamp-1 text-xs font-medium text-emerald-700">
                          {booking.pickup_address_name || 'Pickup'}: {booking.pickup_address}
                        </div>
                        <div className="line-clamp-1 text-xs font-medium text-rose-700">
                          {booking.drop_address_name || 'Drop'}: {booking.drop_address}
                        </div>
                        {booking.total_points > 0 && (
                          <span className="text-[10px] bg-blue-50 text-blue-600 px-1.5 py-0.5 rounded font-bold">
                            +{booking.total_points} Stops
                          </span>
                        )}
                      </td>
                      <td className="py-3 text-right font-bold text-gray-900">
                        £{booking.price}
                      </td>
                      <td className="py-3 text-center">
                        <button
                          type="button"
                          onClick={() => handleViewDetails(booking)} // Pass the whole booking object
                          className="p-2 text-emerald-600 hover:bg-emerald-50 rounded-full transition-all"
                        >
                          <Eye size={18} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
      {isModalOpen && selectedBooking && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
          <div className="bg-white w-full max-w-2xl rounded-3xl shadow-2xl overflow-hidden max-h-[90vh] flex flex-col">
            {/* Modal Header */}
            <div className="p-6 border-b border-gray-100 flex justify-between items-center bg-gray-50">
              <div>
                <h3 className="text-xl font-bold text-gray-900">Booking Details</h3>
                <p className="text-sm text-gray-500">ID: #{selectedBooking.booking.id}</p>
              </div>
              <button onClick={() => setIsModalOpen(false)} className="p-2 hover:bg-gray-200 rounded-full transition-colors">
                <X size={24} />
              </button>
            </div>

            <div className="p-6 overflow-y-auto space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-3">
                  <h4 className="font-bold text-gray-700 flex items-center gap-2 border-b pb-2"><User size={16} /> Customer</h4>
                  <p className="text-sm"><strong>Name:</strong> {selectedBooking.booking.name}</p>
                  <p className="text-sm"><strong>Phone:</strong> {selectedBooking.booking.phone_number}</p>
                  <p className="text-sm"><strong>Email:</strong> {selectedBooking.booking.email}</p>
                </div>
                <div className="space-y-3">
                  <h4 className="font-bold text-gray-700 flex items-center gap-2 border-b pb-2"><Clock size={16} /> Schedule</h4>
                  <p className="text-sm"><strong>Date:</strong> {selectedBooking.booking.journey_date}</p>
                  <p className="text-sm"><strong>Time:</strong> {selectedBooking.booking.journey_time}</p>
                  <p className="text-sm"><strong>Status:</strong>
                    <span className={cn("ml-2 px-2 py-0.5 rounded text-xs font-bold",
                      selectedBooking.booking.status == 1 ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700")}>
                      {selectedBooking.booking.status == 1 ? 'Confirmed' : 'Pending'}
                    </span>
                  </p>
                </div>
              </div>

              <div className="space-y-4">
                <h4 className="font-bold text-gray-700 flex items-center gap-2 border-b pb-2"><MapPin size={16} /> Journey Route</h4>

                <div className="relative pl-6 border-l-2 border-dashed border-gray-200 space-y-6">
                  <div className="relative">
                    <div className="absolute -left-[31px] top-0 w-4 h-4 bg-emerald-500 rounded-full border-4 border-white shadow-sm"></div>
                    <p className="text-xs font-bold text-emerald-600 uppercase">Pickup</p>
                    <p className="text-sm font-medium">{selectedBooking.booking.pickup_address}</p>
                    {selectedBooking.booking.pickup_notes && <p className="text-xs text-gray-500 italic">Note: {selectedBooking.booking.pickup_notes}</p>}
                  </div>

                  {selectedBooking.points && selectedBooking.points.map((pt, idx) => (
                    <div key={idx} className="relative">
                      <div className="absolute -left-[31px] top-0 w-4 h-4 bg-blue-500 rounded-full border-4 border-white shadow-sm"></div>
                      <p className="text-xs font-bold text-blue-600 uppercase">Stop {idx + 1}</p>
                      <p className="text-sm font-medium">{pt.points_address}</p>
                    </div>
                  ))}

                  <div className="relative">
                    <div className="absolute -left-[31px] top-0 w-4 h-4 bg-rose-500 rounded-full border-4 border-white shadow-sm"></div>
                    <p className="text-xs font-bold text-rose-600 uppercase">Destination</p>
                    <p className="text-sm font-medium">{selectedBooking.booking.drop_address}</p>
                    {selectedBooking.booking.drop_notes && <p className="text-xs text-gray-500 italic">Note: {selectedBooking.booking.drop_notes}</p>}
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 p-4 rounded-xl grid grid-cols-3 gap-4 text-center">
                <div>
                  <p className="text-xs text-gray-500 uppercase font-bold">Passengers</p>
                  <p className="text-lg font-bold">{selectedBooking.booking.people}</p>
                </div>
                <div>
                  <p className="text-xs text-gray-500 uppercase font-bold">Luggage</p>
                  <p className="text-lg font-bold">{selectedBooking.booking.luggage}</p>
                </div>
                <div>
                  <p className="text-xs text-gray-500 uppercase font-bold">Total Price</p>
                  <p className="text-lg font-bold text-emerald-600">£{selectedBooking.booking.price}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>

  );
};
